import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'reactstrap';
import intro_tt from '../../../assets/img/infographic.svg'
import ReactGA from 'react-ga';
import { Disclaimers } from '../common';
import { trackingActions } from '../../../core/tracking';

class Ready extends Component{

  handleClick = ( event ) => {
    const { hanndleNextQuestion } = this.props
    ReactGA.event({
        category: 'Thinking Talent',
        action: 'Creation started'
    })
    this.props.saveTrackingEvent({category: 'Thinking Talent', action: 'Creation started'})

    hanndleNextQuestion( 'questions' );
  }

  render() {
    this.handleClick();

    return (
      <>
      <Row>
        <Col lg={{ size: 7 }} className='mx-auto'>
          <div className='pt-md-3 px-md-3 rounded border-md'>
            <div className='mb-3'>
              <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Ready!</h1>
              <p className='mb-3'><strong>The quiz will describe 35 talents.<br/>Take your time answering Always, Sometimes or Never for each one.</strong></p>
              <p className='mb-3'>Your goal is to have <strong>5-8 Always</strong> when finished and there is no way you can be wrong.</p>
              <p className='mb-5'><strong>Remember:</strong> <br/>A <strong>talent</strong> is energizing and something you <strong>cannot help but do.</strong></p>
              <img top src={intro_tt} alt="Thinking Talents" className="img-fluid mx-auto d-block mb-5" />
              <p className='text-center h4 mb-4'>Let's GO!</p>
              <button onClick={this.handleClick.bind(this)} className="btn btn-green-light btn-sm mx-auto px-3 d-block mb-5">
                <i class="mr-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19" style={{ marginBottom: '2px'}}>
                        <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z"/>
                    </svg>
                </i>
                Next
              </button>
            </div>
            <Disclaimers view="propiedad-intelectual" />
          </div>
        </Col>
      </Row>
    </>
    )
  }
}

const mapStateToProps = (state, props) => {
    
  };
  
  const mapDispatchToProps = {
    saveTrackingEvent: trackingActions.saveTrackingEvent
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(Ready);
